import { CommonState } from 'common/types/commonState'
import { ArticleDetailState } from 'common/types/entities/news'
import { fetchArticleDetail } from 'common/services/news'
import { StateKey } from 'common/utils/flipState'
import { createCacheParam, isCacheHit } from 'common/utils/reduxCache'

const initialState: ArticleDetailState = {
  contentsBBSVO: {
    id: null,
    bbsCategoryType: null,
    bbsTitle: null,
    readCount: null,
    regDate: null,
    contentsDisplayStatusType: null,
  },
  editorDetailContentVO: {
    contentId: null,
    editorType: null,
    textContent: null,
    renderContent: null,
    mobileRenderContent: null,
  },
  content: null,
  cacheParam: null,
}

const FETCH = '/news/articleDetail/FETCH'

export const fetch = (curState: StateKey, param) => async (dispatch, getState: () => CommonState) => {
  const cacheParam = createCacheParam(FETCH, 'fetch', { curState, param })
  if (isCacheHit(getState().articleDetail[curState], cacheParam)) {
    return
  }
  const result = await fetchArticleDetail(param)
  dispatch({
    curState,
    cacheParam,
    type: FETCH,
    payload: result || initialState,
  })
}

const articleReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH: {
      return {
        ...action.payload,
        cacheParam: action.cacheParam,
      }
    }
    default:
      return state
  }
}

export default articleReducer
